import React, { useState, useEffect } from "react";
import HindiSlider from "./components/HindiSlider";
import Footer from "./components/Footer";
import Testimonial from "./components/Testimonial";
import AnimatedGallery from "./components/AnimatedGallery";

const bannerSlides = [
  {
    image: "/images/banner1.jpeg",
    heading: "Premium Girls Hostel in Kota",
    subtext: "Safe, Secure, and Student-Friendly Environment",
  },
  {
    image: "/images/banner2.jpeg",
    heading: "Fully Furnished AC Rooms",
    subtext: "Comfortable stay for focused learning",
  },
  {
    image: "/images/banner3.jpeg",
    heading: "Nutritious Home-style Meals",
    subtext: "Fresh and healthy food everyday",
  },
  {
    image: "/images/banner4.jpeg",
    heading: "24/7 Security and CCTV",
    subtext: "Your safety is our priority",
  },
  {
    image: "/images/banner5.jpeg",
    heading: "Spacious Study Areas",
    subtext: "Ideal environment for self-study",
  },
  {
    image: "/images/banner6.jpeg",
    heading: "Regular Cleaning & Laundry",
    subtext: "Hygiene maintained for well-being",
  },
  {
    image: "/images/banner7.jpeg",
    heading: "Nearby Coaching Institutes",
    subtext: "Located in the heart of Kota",
  },
  {
    image: "/images/banner8.jpeg",
    heading: "Friendly Warden & Staff",
    subtext: "We care like family",
  },
];

function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % bannerSlides.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isHovered]);

  const { image, heading, subtext } = bannerSlides[currentSlide];

  return (
    <div className={`font-sans transition-colors duration-300 scroll-smooth ${darkMode ? "bg-gray-900 text-white" : "bg-white text-black"}`}
    style={{ backgroundImage: "url(/images/bg-pattern.png)", backgroundRepeat: "repeat" }}
  >
    <nav className="bg-gradient-to-r from-purple-700 via-pink-600 to-red-500 text-white p-4 sticky top-0 z-50 shadow-md">
      <div className="flex justify-between items-center max-w-7xl mx-auto">
        <a href="#banner" className="text-2xl font-extrabold tracking-wider hover:underline">Navya Residency</a>
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white focus:outline-none"
            >
              ☰
            </button>
          </div>
          <div className="hidden md:flex space-x-4">
            <a href="#about" className="hover:underline">About</a>
            <a href="#facilities" className="hover:underline">Facilities</a>
            <a href="#gallery" className="hover:underline">Gallery</a>
            <a href="#contact" className="hover:underline">Contact</a>
          </div>
          <button
            onClick={() => setDarkMode(!darkMode)}
            className="ml-4 p-2 bg-white text-black rounded-full shadow hover:bg-gray-100 transition"
            title="Toggle light/dark mode"
          >
            {darkMode ? "🌞" : "🌙"}
          </button>
        </div>
        {isMenuOpen && (
          <div className="md:hidden mt-4 space-y-2 text-center">
            <a href="#about" className="block hover:underline">About</a>
            <a href="#facilities" className="block hover:underline">Facilities</a>
            <a href="#gallery" className="block hover:underline">Gallery</a>
            <a href="#contact" className="block hover:underline">Contact</a>
          </div>
        )}
      </nav>

      {/* Banner Section with Slider */}
      <section id="banner"
        className="relative h-[500px] overflow-hidden"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out"
          style={{ backgroundImage: `url('${image}')`, opacity: 1 }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-center items-center text-white text-center p-6">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 drop-shadow animate-fade-in">
            {heading}
          </h2>
          <p className="text-lg md:text-2xl mb-6 animate-fade-in delay-200">
            {subtext}
          </p>
          <a href="#contact" className="bg-pink-500 hover:bg-pink-400 text-white px-8 py-3 rounded-full font-semibold transition-transform transform hover:scale-105">
            Book Your Room
          </a>
        </div>

        {/* Slider Controls */}
        <div className="absolute inset-x-0 bottom-4 flex justify-center space-x-2">
          {bannerSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full border border-white transition-all ${
                currentSlide === index ? "bg-white" : "bg-transparent"
              }`}
            ></button>
          ))}
        </div>
        <button
          onClick={() => setCurrentSlide((currentSlide - 1 + bannerSlides.length) % bannerSlides.length)}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl"
        >
          ❮
        </button>
        <button
          onClick={() => setCurrentSlide((currentSlide + 1) % bannerSlides.length)}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl"
        >
          ❯
        </button>
      </section>
      {/* Intro Section Above HindiSlider */}
      <section className="px-4 py-12 bg-pink-50 dark:bg-gray-900">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-4 text-purple-700 dark:text-white">Why Choose Navya Residency?</h2>
          <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300 mb-6">
            Navya Residency is more than just a girls hostel — it's a safe, supportive space where students can focus on their education, personal growth, and well-being. Designed for excellence and comfort, our facilities cater specifically to the needs of aspiring scholars in Kota.
          </p>
          <a href="#contact" className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-medium shadow-md transition">
            Get in Touch Today
          </a>
        </div>
      </section>

      {/* Hindi Slider */}
      <HindiSlider />
      <section className="px-4 py-10 bg-white dark:bg-gray-800">
        <h2 className="text-3xl font-semibold mb-6 text-center text-pink-600 dark:text-pink-400">Hostel Tour | हॉस्टल टूर</h2>
        <div className="max-w-4xl mx-auto aspect-w-16 aspect-h-9 shadow-lg rounded-xl overflow-hidden">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/Yu1Vfq2c6B8"
            title="Navya Residency Girls Hostel Tour"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </section>
      {/* About Section */}
      <section id="about" className="p-10 bg-purple-50 text-center dark:bg-gray-900">
        <h2 className="text-4xl font-semibold mb-4 text-purple-700 dark:text-purple-300">About Us</h2>
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-6">
          <img src="/images/about.jpeg" alt="About Navya Residency" className="rounded-xl shadow-md w-full md:w-1/2 object-cover h-64" />
          <p className="text-gray-700 text-lg dark:text-gray-300">
            Located in the heart of Kota, Navya Residency offers a secure, clean, and homely environment for girls. Perfect for students preparing for competitive exams.
          </p>
        </div>
      </section>

      {/* Facilities Section */}
      <section id="facilities" className="p-10 bg-white dark:bg-gray-800">
        <h2 className="text-4xl font-semibold text-center mb-6 text-pink-600 dark:text-pink-400">Facilities</h2>
        <div className="grid md:grid-cols-3 gap-6 text-center">
          {["AC Rooms", "24/7 Security", "Nutritious Meals", "Wi-Fi", "Laundry", "Study Area"].map((item) => (
            <div key={item} className="shadow-xl p-6 rounded-xl border border-pink-200 hover:shadow-2xl transition bg-pink-50 dark:bg-gray-700">
              <h3 className="text-xl font-medium text-pink-700 dark:text-pink-200">{item}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="p-10 bg-purple-50 dark:bg-gray-900 text-center">
        <h2 className="text-4xl font-semibold mb-4 text-purple-700 dark:text-purple-300">Gallery</h2>
        <div className="grid md:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((id) => (
            <img
              key={id}
              src={`/images/hostel${id}.jpeg`}
              alt={`Hostel view ${id}`}
              className="rounded-xl w-full object-cover h-60 shadow-lg"
            />
          ))}
        </div>
      </section>
      <AnimatedGallery/>
      <Testimonial/>

      {/* Contact Section */}
      <section id="contact" className="px-4 py-12 bg-gradient-to-br from-pink-50 to-purple-100 dark:from-gray-800 dark:to-gray-900">
        <h2 className="text-3xl font-bold text-center text-purple-800 dark:text-white mb-10">Contact Us | संपर्क करें</h2>
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-start">
          <form className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg space-y-4">
            <input type="text" placeholder="Your Name" className="w-full p-3 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700" />
            <input type="email" placeholder="Your Email" className="w-full p-3 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700" />
            <textarea placeholder="Your Message" rows="5" className="w-full p-3 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700"></textarea>
            <button type="submit" className="bg-pink-500 hover:bg-pink-600 text-white px-6 py-2 rounded font-semibold transition">Send Message</button>
          </form>
          <div className="space-y-4">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-pink-600 dark:text-pink-400 mb-2">Address</h3>
              <p className="text-gray-700 dark:text-gray-300">
                Navya Residency...<br />
                Plot No. H 10, Landmark City, Kunadi,<br />
                Kota-Rajasthan - 324008<br />
                (Near By Allen Sangyan)
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-pink-600 dark:text-pink-400 mb-2">Contact Number</h3>
              <p className="text-gray-700 dark:text-gray-300 space-y-1">
                <a href="tel:+917947435882" className="block hover:text-pink-500">+91 7947435882</a>
                <a href="tel:+919993025577" className="block hover:text-pink-500">+91 9993025577</a>
                <a href="tel:+919828163255" className="block hover:text-pink-500">+91 9828163255</a>
              </p>
            </div>
            <a href="https://wa.me/919993025577" target="_blank" rel="noopener noreferrer" className="block bg-green-500 hover:bg-green-600 text-white text-center py-2 px-4 rounded shadow transition font-semibold">Chat on WhatsApp</a>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <iframe
                title="Navya Residency Location Map"
                src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d1652.3025325396954!2d75.82820100000002!3d25.198104!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDExJzUyLjMiTiA3NcKwNDknNDEuNCJF!5e1!3m2!1sen!2sin!4v1744391810349!5m2!1sen!2sin" 
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>


      <Footer />
    </div>
  );
}

export default App;
 